export const buildId = process.env.NEXT_PUBLIC_BUILD_ID as string

export const appName = 'angel-web'
